import React from "react";
import { Box, Typography, Button } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { theme } from "../../theme/colors";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";

export default function AccountManagementSection() {
  const navigate = useNavigate();
  const { accountTypeName, verifiedUser } = useUser();

  const getAccountTypeTitle = () => {
    if (!accountTypeName) return "Citizen";
    const name = String(accountTypeName).toLowerCase();
    if (name === "user" || name === "citizen") return "Citizen";
    return String(accountTypeName).replace(/_/g, " ").replace(/\b\w/g, (ch) => ch.toUpperCase());
  };

  const isCitizen = !accountTypeName || accountTypeName === "citizen" || accountTypeName === "user";

  return (
    <Box id="account-type" sx={{ mb: 0, scrollMarginTop: "88px" }}>
      <Typography variant="h6" component="h2" sx={{ fontWeight: 700, color: "#111", mb: 2 }}>
        Account Type: {getAccountTypeTitle()}
        {!isCitizen && (
          <Box component="span" sx={{ fontWeight: 500, color: verifiedUser ? theme.primary : "#d97706", ml: 0.5 }}>
            {verifiedUser ? " (Verified)" : " (Verification pending)"}
          </Box>
        )}
      </Typography>

      <Button
        fullWidth
        variant="outlined"
        onClick={() =>
          navigate("/account-type-selection", {
            state: {
              changeMode: true,
              currentAccountType: accountTypeName,
              cancelTo: "/account-details",
            },
          })
        }
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1.5,
          px: 2,
          textTransform: "none",
          color: "#334155",
          borderColor: "#e2e8f0",
          borderRadius: "12px",
          bgcolor: "#fff",
          "&:hover": {
            bgcolor: "#f8fafc",
            borderColor: "#cbd5e1",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <SwapHorizIcon sx={{ color: theme.primary }} />
          <Typography sx={{ fontWeight: 600 }}>Change Account Type</Typography>
        </Box>
        <ChevronRightIcon sx={{ color: "#94a3b8" }} />
      </Button>
    </Box>
  );
}
